import {createAsyncThunk, createEntityAdapter, createSlice} from "@reduxjs/toolkit";
import {getSellerReportDataApi} from "../../../../services/report";
import {exportSalesReportApi, getCustomerListApi} from "../../../../services/backStock";


export const getSalesReportData = createAsyncThunk('report/sales-report', async (data, {dispatch}) => {
    const response = await getSellerReportDataApi(data);
    dispatch(setTableRowCount(response.response.count))
    dispatch(setTotalAmount(response.response.total))
    dispatch(setSummary(response.response))
    return response.response.data;
});

export const getCustomerList = createAsyncThunk('report/sales-report/get-customer-list', async (data, {dispatch})=>{
    const response = await getCustomerListApi();
    return response.response;
});

export const exportSalesReport = createAsyncThunk('report/exportFinancesSalesDetails', async (data, { dispatch }) => {
    const response = await exportSalesReportApi(data);
    return response.response;
});

const salesReportAdapter = createEntityAdapter({});

export const {selectAll: selectSalesReport, selectById: selectSalesReportById} = salesReportAdapter.getSelectors(
    state => state.report.salesReport
);

const salesReportSlice = createSlice({
    name: 'sellerReport',
    initialState: salesReportAdapter.getInitialState({
            id: null,
            searchText: '',
            salesReportTableRow:0,
            totalAmount:0,
            customers:'',
            summary : {
                totalItemsSold : 0,
                totalOrders : 0,
                totalReturns : 0,
                totalCustomers : 0,
                totalUniqueCustomers : 0,
                totalGrossSales : 0,
                totalNetSales : 0,
                averageOrderValue : 0,
                averageRevenuePerCustomer : 0,
                repeatPurchaseRate : 0,
                returnRate : 0,
                
            }
        }),
    reducers: {
        setTableRowCount: (state, action) => {
            state.salesReportTableRow = action.payload;
        },
        setTotalAmount: (state, action) => {
            state.totalAmount = action.payload;
        },
        setCustomers: (state, action) => {
            state.customers = action.payload.customers;
        },
        setSummary : (state, action) => {
            state.summary.totalItemsSold = action.payload.total_items_sold;
            state.summary.totalOrders = action.payload.total_orders;
            state.summary.totalReturns = action.payload.total_return;
            state.summary.totalCustomers = action.payload.total_customers;
            state.summary.totalUniqueCustomers = action.payload.total_unique_customer;
            state.summary.totalGrossSales = action.payload.total_gross_sales;
            state.summary.totalNetSales = action.payload.total_net_sales;
            state.summary.averageOrderValue = action.payload.average_order_value;
            state.summary.averageRevenuePerCustomer = action.payload.average_revenue_per_customer;
            state.summary.repeatPurchaseRate = action.payload.repeat_purchase_rate;
            state.summary.returnRate = action.payload.return_rate;
        }
    },
    extraReducers: {
        [getSalesReportData.fulfilled] : salesReportAdapter.setAll
    }
});

export const {setTableRowCount,setTotalAmount, setCustomers, setSummary} = salesReportSlice.actions;

export default salesReportSlice.reducer;